import React, { useCallback, useMemo } from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { goToOrderDetails } from '../../../../../../store/orders/order-details/orders.details.actions';
import * as OrderStatuses from '../../../../../../filters/options/order-status/options';
import { usePickToToteFeatureEnabled } from '../../../../../../feature-flags/hooks/use-pick-to-tote-feature-enabled';
import Global from '../../../../../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import { messages } from '../messages';
import style from '../style.module.css';

export const InventoryAllocation = ({ orderNumber, orderStatus, numberAllocated, fulfillmentPlanId, toteId }) => {
  const dispatch = useDispatch();
  const isToteFeatureEnabled = usePickToToteFeatureEnabled();
  const [salesOrderId] =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: [fulfillmentPlanId],
      }),
    ) ?? emptyArray;

  const totes = useSelector(Global.selectSellerTotes) ?? emptyArray;

  const toteName = useMemo(() => {
    if (!toteId) return '';
    const tote = totes.find((t) => t.toteId === toteId);
    return tote?.toteName ?? '';
  }, [toteId, totes]);

  const onOrderNumberClick = useCallback(() => {
    dispatch(goToOrderDetails({ salesOrderId, fulfillmentPlanId }));
  }, [dispatch, salesOrderId, fulfillmentPlanId]);
  const statusValue = Object.values(OrderStatuses).find((stat) => stat.apiKey === orderStatus);
  const statusFormattedMessage =
    orderStatus.length && statusValue ? statusValue.component : <FormattedMessage {...messages.orderStatusUndefined} />;
  return (
    <div className={classnames(style['allocations-body'], { [style['allocations-with-tote']]: isToteFeatureEnabled })}>
      <div>
        <Button disabled={!salesOrderId} onClick={onOrderNumberClick} theme='link'>
          {orderNumber}
        </Button>
      </div>
      <div>{statusFormattedMessage}</div>
      <div className={style.centered}>{numberAllocated}</div>
      {isToteFeatureEnabled && <div className={style['text-overflow']}>{toteName}</div>}
    </div>
  );
};

InventoryAllocation.propTypes = {
  orderNumber: PropTypes.string.isRequired,
  orderStatus: PropTypes.string.isRequired,
  numberAllocated: PropTypes.number.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
  toteId: PropTypes.number,
};
